import { AlertOctagramIcon } from './AlertOctagramIcon';

/**
 * author: Austin Andrews
 * id 124F37BE-27F6-4524-9655-A18D28E91CA6
 * name alert-octagram
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-octagram.svg
 * tags
 * - Alert / Error 
 */
export const WarningOctagramIcon = AlertOctagramIcon;
export default WarningOctagramIcon